import React from 'react'
import {Grid} from '@material-ui/core'
import {RootGrid, Title, Text, AppstoreButton, AppstoreImage} from './styled'
import {RouteComponentProps} from 'react-router'
import qs from 'qs'
import {Dictionary} from 'lodash'

const appstoreUrl = 'https://apps.apple.com/us/app/body-engineering/id1588772664'

export type TParams = {
  title: string
  imageUrl: string
}
export type ShareProps = RouteComponentProps<TParams> & {}

const MobilePage: React.FC<ShareProps> = ({location}) => {
  const {title, imageUrl} = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  }) as Dictionary<string>
  return (
    <RootGrid container spacing={3}>
      <img alt={title} src={imageUrl} />
      <Grid item xs={12}>
        <Title>{title}</Title>
      </Grid>
      <Grid item xs={12}>
        <Text>{`You can view this content in our app by downloading it from the App Store!`}</Text>
      </Grid>

      <AppstoreButton onClick={() => window.location.replace(appstoreUrl)}>
        <AppstoreImage variant="square" src="/assets/Appstore.png" />
      </AppstoreButton>
    </RootGrid>
  )
}

export default MobilePage
